
<textarea
  ref="textarea"
  v-model="textValue"
  :placeholder="placeholder"
  :name="name"
  :maxlength="maxlength"
/>
